export const PROSODY_EMOTION_CONFIG = {
  angry:          { scorable: ['Angry'], baseline: { Angry: 3 } },
  excited:        { scorable: ['Happy', 'Surprise'], baseline: { Happy: 3, Surprise: 2 } },
  concerned:      { scorable: ['Fear', 'Sad'], baseline: { Fear: 2, Sad: 1 } },
  unenthusiastic: { scorable: ['Sad'], baseline: { Sad: 1 } },
  enthusiastic:   { scorable: ['Happy', 'Surprise'], baseline: { Happy: 3, Surprise: 1 } },
  embarrassed:    { scorable: ['Fear', 'Sad'], baseline: { Fear: 2, Sad: 1 } },
  proud:          { scorable: ['Happy'], baseline: { Happy: 2 } }
};
